exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".OfferPopup_offerContent_3AQS {\n  text-align: justify;\n}\n", ""]);

// exports
exports.locals = {
	"offerContent": "OfferPopup_offerContent_3AQS"
};